import { Trophy, Star, SealCheck, Fire, Medal, Heart } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../../library/LibraryPrimitives";
import { AreaNode } from "../diagrams";

export function RewardsSection() {
  return (
    <SectionShell
      id="rewards"
      eyebrow="Rewards"
      eyebrowIcon={Trophy}
      title="Celebrating growth, not winning"
      description="Rewards exist to encourage effort and curiosity — not to rank children against each other. There are no leaderboards. Every child's journey is celebrated on its own terms."
    >
      <div className="space-y-8">
        <Showcase title="What we celebrate" tone="muted">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <AreaNode icon={Star} label="XP" purpose="Effort points for trying" tone="yellow" />
            <AreaNode icon={SealCheck} label="Badges" purpose="Milestones & moments" tone="blue" />
            <AreaNode icon={Fire} label="Streaks" purpose="Gentle daily habit" tone="orange" />
            <AreaNode icon={Medal} label="Achievements" purpose="Big proud unlocks" tone="teal" />
          </div>
        </Showcase>

        <div className="grid gap-4 sm:grid-cols-3">
          {[
            { t: "Effort over outcome", d: "XP rewards showing up and trying — not just being right." },
            { t: "No competition", d: "No leaderboards or rankings. The only comparison is yesterday's self." },
            { t: "Surprise & delight", d: "Unexpected celebrations keep motivation warm, not transactional." },
          ].map(({ t, d }) => (
            <div key={t} className="rounded-3xl border border-border bg-card p-5 shadow-soft">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary/12 text-primary-strong"><Heart size={22} weight="fill" /></span>
              <p className="mt-3 font-display font-extrabold">{t}</p>
              <p className="mt-1 text-sm font-medium leading-relaxed text-muted-foreground">{d}</p>
            </div>
          ))}
        </div>

        <p className="rounded-3xl border border-border bg-accent/50 p-5 font-medium text-foreground">
          <strong>Scope note:</strong> this defines the <em>motivational</em> architecture only. The reward <em>economy</em> (costs, unlock rules, balancing) is intentionally deferred.
        </p>
      </div>
    </SectionShell>
  );
}

export default RewardsSection;
